import { createRouter, createWebHistory } from 'vue-router'
import Browser from '@/utils/browser'

const loadComp = url => {
  return () => {
    if (Browser.mobile) {
      return import(url.replace('/pages', '/mPages'))
    }
    return import(url)
  }
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => {
      if (Browser.mobile) {
        return import('@/mPages/index')
      }
      return import('@/pages/index')
    }
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('@/pages/product/gere')
  },
  {
    path: '/sn/contact',
    name: 'contact',
    component: () => import('@/pages/contact')
  },
  {
    path: '/sn/:type',
    name: 'sn',
    component: () => {
      if (Browser.mobile) {
        return import('@/mPages/aboutDetail/index')
      }
      return import('@/pages/sn')
    }
  },
  {
    path: '/product',
    name: 'product-page',
    component: () => {
      if (Browser.mobile) {
        return import('@/mPages/product/index')
      }
      return import('@/pages/product/product')
    }
  },
  {
    path: '/product/:type',
    name: 'product',
    component: () => import('@/pages/product')
  },
  {
    path: '/product/:type/detail',
    name: 'product-detail',
    component: () => {
      if (Browser.mobile) {
        return import('@/mPages/productDetail/index')
      }
      return import('@/pages/product-detail')
    }
  },
  {
    path: '/service/quote',
    name: 'quote',
    component: () => {
      if (Browser.mobile) {
        return import('@/mPages/quote/index')
      }
      return import('@/pages/quote')
    }
  },
  {
    path: '/warranty/index',
    name: 'warranty',
    component: () => {
      if (Browser.mobile) {
        return import('@/mPages/warranty/index')
      }
      return import('@/pages/warranty')
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
